import { render, staticRenderFns } from "./purchaseRefundAction.vue?vue&type=template&id=23e6b54c&scoped=true"
import script from "./purchaseRefundAction.vue?vue&type=script&lang=js"
export * from "./purchaseRefundAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseRefundAction.vue?vue&type=style&index=0&id=23e6b54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6b54c",
  null
  
)

export default component.exports